import PropTypes from 'prop-types';
import React, {Component} from 'react';

//Components
import Loader from '../../../components/loader.jsx';
import SummarySectionPOSDate from '../components/summarySectionPosDate';
import BulletList from 'helpers/bulletList.jsx';

//Apis
import ReportApi from '../../../../api/report.jsx';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import ReportSummaryErrorHandler from '../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';

import {scheduleReports, scheduleReportExportURL} from 'helpers/constants.jsx';


class AccountListReport extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    dealer: PropTypes.object,
    POSActive: PropTypes.bool,
  };

  constructor(props) {
    super(props);
  }

  state = {
    loaded: true,
    report: null,
    showNoDataMessage: false,
    error: false,
  };

  componentDidMount() {
    this.setState({
      loaded: false,
      error: false,
    });
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        report: null,
      });
    }

    (this.fetching = makeCancelable(ReportApi.getScheduledReportDetails([
      scheduleReports.CustomerList,
    ])))
    .then(res => {
      const data = this.formatReportsDataResponse(res);

      if(data) {
        this.setState({
          report: data,
          loaded: true,
          showNoDataMessage: false,
          error: false,
        });
      } else {
        this.setState({loaded: true, showNoDataMessage: true, error: false});
      }
    }).catch(e => {
      console.log(e);
      if (e && e.canceled) {return;}
      this.setState({loaded: true,showNoDataMessage: true});
    });
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  componentDidCatch(error, errorInfo) {
    console.log(error,errorInfo);
    this.setState({
      error: true,
    });
  }

  export = (URL) => {
    window.open(URL, '_blank');
  };

  formatReportsDataResponse(data) {
    if(data && data[0]) {
      return data[0] || null;
    }
    return null;
  }


  render() {
    const {loaded, showNoDataMessage, report} = this.state;
    const {locale} = this.props.intl;
    const exportURLKey = locale === 'fr-CA' ? scheduleReportExportURL.XLSX_FR :  scheduleReportExportURL.XLSX;

    return (
      <div className='report-container'>
        <div className='description'>
          <FormattedMessage id="reports.all.accounts.description" />
        </div>
        <div>
          <FormattedMessage id="reports.thingstoknow" />
          <FormattedMessage id="reports.thingstoknow.customer-list">
            {x => <BulletList text={x} />}
          </FormattedMessage>
        </div>
        <Loader loaded={loaded}>
          <ReportSummaryErrorHandler error={this.state.error}>
            <SummarySectionPOSDate POSActive={this.props.POSActive} dealer={this.props.dealer} />
            {showNoDataMessage || !report || !report[exportURLKey] ? <label className='report-no-data'><FormattedMessage id='reports.error.no.results' /></label> :
            <div className='col-sm-12 button-group shift-right'>
              <button className='btn btn-primary pull-right'
                onClick={() => this.export(report[exportURLKey])}>
                <FormattedMessage id='general.download' />
              </button>
            </div>
            }
          </ReportSummaryErrorHandler>
        </Loader>
      </div>
    );
  }
}

AccountListReport.propTypes = {
  POSActive: PropTypes.bool,
  TruBlueActive: PropTypes.bool,
  dealer: PropTypes.any,
};

AccountListReport.defaultProps = {
  POSActive: false,
};

export default injectIntl(AccountListReport);
